import { render } from "./index.vue?vue&type=template&id=55a02846&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=55a02846&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-55a02846"

export default script